module.exports = __webpack_public_path__ + "static/media/telephone_icon.2b0a66d6.svg";